import React, { useEffect, useState } from "react";
import { Parallax } from "react-parallax";
import axios from "axios";
import image2 from "../Assets/page_bg.jpg";
import Footer from "./Footer";
import Header from "./Header";
// import image1 from "../Assets/home_shasti.png";
import { Link } from "react-router-dom";
import CrackersLoader from './CrackersLoader';
import Stats from "./Stats";
// import image from "../Assets/about-content.jpg";
import side_image from "../Assets/profile-image.jpg";
import { Button } from "react-bootstrap";
import Sticker from "./Sticker";


function About() {
  const [aboutData, setAboutData] = useState(null);
  const [showDos, setShowDos] = useState(true);
  const [contactData, setContactData] = useState(null);
  const [isLoading, setIsLoading] = useState(true); // State to manage loading
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

 
  useEffect(() => {
    const fetchAboutData = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}content.php`
          // " https://manifriendstraders.com/customer_api/content.php"
        );
        const { body } = response.data;
        setAboutData(body.about);
        setContactData(body.contact);
      } catch (error) {
        console.error("Error fetching the about data", error);
      }finally {
              setIsLoading(false); // Stop loading after data is fetched
            }
    };

    fetchAboutData();
  }, []);

  // Fallback content if data is not loaded
  if (isLoading) {
    return <CrackersLoader />; // Show the custom loader while fetching data
  }

  

  return (
    <div>
      <div className="main-homepage">
        <Header />

        {/* Parallax Section */}
        <Parallax
          bgImage={image2}
          bgImageAlt="the cat"
          // strength={500}
          style={{ minHeight: "100px" }}
          
        >
          <div style={{ height: "230px" }}>
            <h1
              style={{
                color: "white",
                paddingTop: "100px",
                textAlign: "center",
              }}
            >
              About
            </h1>
            <p
              style={{
                display: "flex",
                justifyContent: "center",
                color: "white",
              }}
            >
              <Link to="/" style={{color:"white"}}>
              Home</Link> <i className="bi bi-chevron-right"></i> About Us
            </p>
          </div>
        </Parallax>

        <div className="about-section">
          {/* Top Image */}
          {/* <div className="topimg">
            <img src={image1} alt="" />
          </div> */}
          {/* Content aligned to the right */}
          <div className="content-text">
            <h5 style={{fontWeight:"bold"}}>Our Shop Details</h5>
            <br />
            <h3 style={{ letterSpacing: "2px", color: "darkblue" }}>
             Skandhas Pyropark
            </h3>
            <h4>
              WHOLESALE & RETAIL SHOP IN{" "}
              <span style={{ color: "darkred" }}>VIRUDHUNAGAR</span>
            </h4>
            <br />
            {/* <p style={{ fontFamily: " Arial, Helvetica, sans-serif" }}>
              {aboutData.description}
            </p> */}

            <p
              style={{ fontFamily: " Arial, Helvetica, sans-serif" }}
              dangerouslySetInnerHTML={{ __html: aboutData.value }}
            />
            <br />
            <Stats />
<Sticker /> 
            <br />

            <div className="about-content-section1">
        
        <div className="content-text" style={{fontFamily: "var(--default-font)"}}>
          
          {/* <br /> */}
          <h4 style={{ letterSpacing: "2px", color: "#000",fontFamily: "var(--default-font)" }}>
           ONLINE CRACKERS SHOP <span style={{color:"#ec5d11",fontFamily: "var(--default-font)"}}>VIRUDHUNAGAR</span>
          </h4>
          
        
         <p style={{fontFamily: "var(--default-font)"}}>We are a famous online pattasu kadai in Virudhunagar , with 97 varieties of Virudhunagar crackers on board and purchase through online crackers shopping</p>
         <div className="d-flex" >
         
          <i className="bi bi-cart-check-fill about-content-icon" ></i>&nbsp;&nbsp;&nbsp;
   
          <div>
          <p style={{fontFamily: "var(--default-font)"}}><b>FLAT 80% OFF</b></p>
          <p style={{fontFamily: "var(--default-font)"}}>Online Order for Flat 80% off from a great selection of Fireworks Products at Skandhas Pyropark</p>
          </div>
         </div>
         <div className="d-flex">
          
          <i className="bi bi-gear-fill about-content-icon"></i>&nbsp;&nbsp;&nbsp;
    
          
          <div>
         <p style={{fontFamily: "var(--default-font)"}}><b>BRANDED CRACKERS</b></p>
         <p style={{fontFamily: "var(--default-font)"}}>Spread the Light of Joy and  Happiness with Branded Fire Crackers. Kindly contact us for more details.</p>
         </div>
         </div>
         <div className="d-flex">
          
          <i className="bi bi-geo-alt-fill about-content-icon " ></i>&nbsp;&nbsp;&nbsp;
    
          
          <div>
         <p style={{fontFamily: "var(--default-font)"}}><b>TIMELY DELIVERY</b></p>
         <p style={{fontFamily: "var(--default-font)"}}>Our commitment on quality & timely delivery have been earning reputations from our Happy Customers</p>
        </div>
         </div>
        </div>
        <div className="about-topimg" >
          <img src={side_image} alt="Top" width="100%"/>
        </div>
            {/* <Animation /> */}
            </div>
            <hr />
            <div>
              <h3 style={{fontFamily: "var(--default-font)"}}>
                Call To Ask Any Enquiry{" "}
                <span style={{ color: "red" }}> {contactData.whatsapp_number}</span>
              </h3>
            </div>
          </div>
        </div>
        <Footer />
      </div>
      
      <div className="minifooter1">
      <div className="minimenu">
          
      {/* <Link to="/"> */}
      <Link to="/home">
            <div style={{display:"flex", flexDirection:"column",color:"white"}}>
          <i class="bi bi-house-door" style={{marginLeft:"12px",fontSize:"1.4rem"}}></i>
             Home
             </div>
             </Link>
         
             <Link to="/about">
          <div style={{display:"flex", flexDirection:"column",color:"white"}}>
          <i class="bi bi-journal-text officon" style={{marginLeft:"20px",fontSize:"1.4rem",color:"white"}}></i>
             About Us
             </div>
             </Link>

             
          <Link to="/quick">
          <div style={{display:"flex", flexDirection:"column",color:"white"}}>
          <i class="bi bi-bag" style={{marginLeft:"15px",fontSize:"1.4rem"}}></i>
             Enquiry
             </div>
             </Link>
             
            
         
          <Link to="/contact">
          <div style={{display:"flex", flexDirection:"column",color:"white"}}>
          <i class="bi bi-telephone" style={{marginLeft:"12px",fontSize:"1.4rem"}}></i>
             Contact
             </div>
             </Link>
          
        </div>
      </div>
    </div>
  );
}

export default About;
